export default {

    topic: null,
    isCategoryTopic: false,
    topicsModel: false,

    subtopics: [],

    item: null,

    clickedReferences: [],
    itemContent: null,

    topicsNews: null

}